<template>
  <BaseModal ref="base" name="removeParceiroModal" centered>
    <template #title>
      {{ $t('pagar') }}
    </template>
    <template #body>
      {{ $t('marcarComoPago') }}
    </template>
    <template #footer>
      <LoadingButton type="button" class="btn-primary" :loading="loading" @click="pagar">
        <i class="bi bi-check" /> {{ $t('sim') }}
      </LoadingButton>
      <button type="button" class="btn btn-secondary" @click="hide">
        <i class="bi bi-x" /> {{ $t('nao') }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/modules/core/components/BaseModal.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { useToast } from 'vue-toastification';
import { pagarComissao } from '../comissaoService';

export default {
  components: { BaseModal, LoadingButton },
  props: {
    id: { type: String, required: true },
    renovacoes: { type: Number, required: true },
  },
  emits: ['update-table'],
  data: () => ({ loading: false }),
  methods: {
    show() { this.$refs.base.show(); },
    hide() { this.$refs.base.hide(); },
    async pagar() {
      this.loading = true;
      try {
        if (this.renovacoes > 1) {
          if (await pagarComissao(this.id)) {
            this.$emit('update-table');
            useToast().success('Comissao marcado como pago');
          }
        } else {
          useToast().error('Mínimo de 2 renovações necessárias para pagar');
        }
        this.$refs.base.hide();
      } catch (error) {
        useToast().error('Erro de conexão');
      }
      this.loading = false;
    },
  },
};
</script>
